export const PollResultRatio = ({ totalVotes, votes }: { totalVotes: number; votes: number }) => (
    <span>
        {votes}/{totalVotes}
    </span>
);
